// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components

// Data / Images / Icons

function CertificationCard({ certification }) {
  return (
    <div className="local-theme-bg-md local-theme-border-md shadow-lg rounded-lg p-6 border border-gray-200 flex items-start space-x-4 select-none">
      {/* Certificate Image */}
      <img
        src={
          certification.certificateImg
            ? certification.certificateImg
            : certification.logo
        }
        alt={certification.title}
        className="w-24 h-16 object-cover rounded-md border mt-1"
      />

      {/* Certification Details */}
      <div className="flex-1">
        <h2 className="text-lg font-semibold local-theme-text-md">{certification.title}</h2>

        {/* Issuer with Logo */}
        <div className="flex items-center space-x-2 mt-1">
          <img
            src={certification.logo}
            alt={certification.issuer}
            className="w-5 h-5 object-contain"
          />
          <p className="local-theme-text-xs text-sm">{certification.issuer}</p>
        </div>

        {/* Issue Date & Description */}
        <p className="local-theme-text-xs text-xs mt-2">{certification.issueDate}</p>
        <p className="local-theme-text-sm text-xs mt-1">
          {certification.description}
        </p>
      </div>
    </div>
  );
}

export default CertificationCard;
